import Text from "../../text/Text";
import { Icon } from "../../icon/Icon";
import { isNil } from "lodash-es";
import type { IconOption, ListItemHtmlProps } from "../../../types/Menu";
import ListItemContainer from "./ListItemContainer";

type IconListItemProps = Omit<IconOption<null>, "variant" | "value"> & {
  htmlProps: ListItemHtmlProps | null;
};

const IconListItem = (props: IconListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="row">
    <div class="inline-flex items-center justify-center icon-tertiary">
      <span
        class="size-5 shrink-0 rounded-sm"
        classList={{ [props.icon.class ?? ""]: !isNil(props.icon.class) }}
        style={props.icon.style}
      >
        <Icon name={props.icon.name} type={props.icon.type} size="lg" />
      </span>
    </div>
    <Text as="span" truncate text={props.label} class="text-base-regular text-primary group-disabled:text-disabled" />
  </ListItemContainer>
);

export default IconListItem;
